/**
 * Created by natalia.petrov on 6/26/2017.
 */
export default {
    IFRAME_SRC: 'IFRAME_SRC',
    IFRAME_HEIGHT: 'IFRAME_HEIGHT',
    IFRAME_SCROLL: 'IFRAME_SCROLL',
    GET_CUSTOM_IFRAME:'GET_CUSTOM_IFRAME'
}



// WEBPACK FOOTER //
// ./constants/customIframe.js